import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'; 
import ArrowIcon from '../assets/images/arrow-right.svg' 

function HomeGreatFullLife({data}) {
  if (!data) {
    return null; // Correct return for better handling
  }
  
  return (
    <> 
    <section className="home-great-full-life">
      <Container>
        <Row className="align-items-center">
          <Col sm="12" md="5" className='mb-4 mb-md-0'>
            <img className="home-great-full-life-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data.image}`} alt="" />
          </Col>     
          <Col sm="12" md="7">    
            <div className="home-great-full-life-box">        
              <h2>{data.title}</h2>
              <p>{data.subtitle}</p>
              <Link to={data.btn_link} title={data.btn_name} className="custom-bttn"> {data.btn_name} <img className="arrow-icon-img" src={ArrowIcon} alt="" /></Link> 
            </div>
          </Col>
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default HomeGreatFullLife